import styled from "../../__compat__/styled-components/main.entry.mjs.mjs";
import { responsiveStyles } from "../../utils/responsiveStyles.mjs.mjs";
import { mapStyle } from "../../utils/mapStyle.mjs.mjs";
import { injectSpacing } from "../../api/spacing/injectSpacing.mjs.mjs";
import { AlignMap } from "./LayoutItem.types.mjs.mjs";
export const StyledLayoutItem = styled.div.withConfig({ displayName: "auir-41e20d9-StyledLayoutItem", componentId: "auir-41e20d9-1gy79aj" }) `
  ${(props) => responsiveStyles({
    'align-self': mapStyle(props.align, AlignMap),
    'flex-basis': props.basis,
    'flex-grow': props.grow,
    'flex-shrink': props.shrink,
}, props.theme.breakpoints)}
  ${injectSpacing('margin')}
`;
//# sourceMappingURL=LayoutItem.styles.mjs.mjs.map